/* eslint-disable */
import moment from 'moment';
import 'moment/locale/ru';

export default function checkFlexibleDay({checkInDateRangeFrom = '', daysFlexible = 0} = {}) {
    const today = moment().endOf('day');
    const diff = moment(checkInDateRangeFrom).diff(today, 'days');
    return (diff >= 0 && diff < daysFlexible) ? daysFlexible - diff : 0;
}